import { render, staticRenderFns } from "./YourPolicyBtn.vue?vue&type=template&id=11b436b0&scoped=true&"
import script from "./YourPolicyBtn.vue?vue&type=script&lang=ts&"
export * from "./YourPolicyBtn.vue?vue&type=script&lang=ts&"
import style0 from "./YourPolicyBtn.vue?vue&type=style&index=0&id=11b436b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b436b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
